export const ExcelHeader = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Svc Awb",
    key: "serviceable.awb",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Part Number",
    key: "pn",
  },
  {
    header: "Part Number Desc",
    key: "pnDescription",
  },
  {
    header: "Svc Pn",
    key: "svcPn",
  },
  {
    header: "Svc Sn",
    key: "svcSn",
  },
  {
    header: "Destination",
    key: "airportCode",
  },
  {
    header: "Customer Po",
    key: "customerPo",
  },
  {
    header: "Requested Date",
    key: "requestedDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Status",
    key: "status",
  },
  {
    header: "Serviceable",
    key: "serviceableStatus",
  },
  {
    header: "Core Unit",
    key: "unserviceableStatus",
  },
];
